<template>
    <b-btn v-bind="$attrs" @click.prevent="onClick">
        <slot></slot>
    </b-btn>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        msg: {
            type: String,
            default: '¿Esta seguro de realizar la acción?',
        },
        title: {
            type: String,
            default: 'Por favor confirmar',
        },
        okVariant: {
            type: String,
            default: 'danger',
        },
        id: {
            type: String,
            default: () => `confirm_window_{parseInt(Math.rand()*1000000000)}`,
        },
    },
    methods: {
        onClick() {
            this.$bvModal
                .msgBoxConfirm(this.msg, {
                    title: this.title,
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: this.okVariant,
                    okTitle: 'Confirmar',
                    cancelTitle: 'Cancelar',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                    id: this.id,
                })
                .then((value) => {
                    !!value && this.$emit('confirm')
                    return false
                })
                .catch((error) => {
                    this.$emit('error', error)
                })
        },
    },
}
</script>
